const HARDWARE_DEVICES = [
    {
        id: 'domiCar',
        name: 'Domi 小车',
        modes: ['online', 'upload'],
        connections: [
            {id: 'wifi', modes: ['online', 'upload']},
            {id: 'serial', modes: ['online', 'upload']}
        ]
    },
    {
        id: 'domiAiRound',
        name: 'Domi AI 圆屏',
        modes: ['online'],
        connections: [
            {id: 'wifi', modes: ['online']},
            {id: 'usb', modes: ['online']}
        ]
    },
    {
        id: 'microbit',
        name: 'micro:bit',
        modes: ['online', 'upload'],
        connections: [
            {id: 'bluetooth', modes: ['online']},
            {id: 'usb', modes: ['upload']}
        ]
    }
];

const getHardwareDevice = deviceId => HARDWARE_DEVICES.find(device => device.id === deviceId) || null;

const appendHardwareDevice = (devices, deviceId) => {
    const device = getHardwareDevice(deviceId);
    if (!device || devices.some(existingDevice => existingDevice.id === deviceId)) return devices;
    return devices.concat(device);
};

const getAvailableHardwareDevices = extensionManager => HARDWARE_DEVICES.filter(device => (
    extensionManager.isExtensionLoaded(device.id)
));

const getCompatibleConnections = (device, mode) => (
    device ? device.connections.filter(connection => connection.modes.includes(mode)) : []
);

const getDefaultConnectionType = (device, mode) => {
    const [connection] = getCompatibleConnections(device, mode);
    return connection ? connection.id : null;
};

export {
    appendHardwareDevice,
    getAvailableHardwareDevices,
    getCompatibleConnections,
    getDefaultConnectionType,
    getHardwareDevice,
    HARDWARE_DEVICES
};
